import PropTypes from "prop-types";
import React from "react";

import i18n from "@swa-ui/locale";
import { classNames } from "@swa-ui/string";

import { getAirlineNameByIATA } from "../airlines";
import styles from "./FlightAirlineOperator.module.scss";

/**
 * FlightAirlineOperator displays the name of the flight's airline operator
 */

export const FlightAirlineOperator = (props) => {
  const { airlineIATADesignator, className } = props;
  const airlineName = getAirlineNameByIATA(airlineIATADesignator);

  return (
    <div className={classNames(styles.airlineOperatorName, className)}>
      {i18n("FlightAirlineOperator__AIRLINE_OPERATOR", airlineName)}
    </div>
  );
};

FlightAirlineOperator.propTypes = {
  /** The required IATADesignator of the airline operating the flight */
  airlineIATADesignator: PropTypes.string.isRequired,

  /** An additional classname for the component */
  className: PropTypes.string,
};
